// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1xKuw","actions":"GroupTable_actions__101Tm","deleteModalFooter":"GroupTable_deleteModalFooter__20Yg-"};